import { httpGet, httpPost } from "../../utils/httpMethods";
import { AUTH_URL, EMPLOYEE_URL } from "../restEndpoint";

export const getEmployees = async (organizationId) => {
  return await httpGet({ 
    url: `${EMPLOYEE_URL}/${organizationId}` 
  })
  .then((res) => {
    return res.data;
  })
  .catch((err) => {
    throw err;
  });
}

// Employee End Points to add new employees to organization
export const createEmployee = async (employeeData) => {
  return await httpPost({ url: `${AUTH_URL}/signup`, payload: employeeData })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
}

export const loginEmployee = async (employeeData) => {
  return await httpPost({ url: `${AUTH_URL}/login`, payload: employeeData })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
}